import React from "react";
import { Schema } from "rsuite";
import Form from "rsuite/es/Form";
import styled from "styled-components";

import FormHOC from "hoc/FilltersForm";
import Text from "components/Form/Text";

const { StringType } = Schema.Types;

const filtersModel = Schema.Model({
    str: StringType().maxLength(256, "The maximum is only 256 characters."),
});


const SearchFilter = ({ onChange, defaultFilters }) => {
    return (
        <>
            <Form
                model={filtersModel}
                layout="inline"
                onChange={onChange}
                formDefaultValue={defaultFilters}
            >
                <StyledTextField
                    name="str"
                    placeholder="Sender ID/Origin/Message"
                />
            </Form>
        </>
    );
};

export default FormHOC(SearchFilter, filtersModel, 800);

const StyledTextField = styled(Text)`
    &&& {
        width: 100%;
        min-width: 300px;
    }
`;
